import supportService from '../../services/support'
import { KEYWORDS } from "../../constants/support";

export default {
  namespaced: true,
  state: {
    psySupport: null,
    socialSupport: null
  },
  mutations: {
    SET_PSYCHO_SUPPORT(state, support) {
      state.psySupport = support
    },
    SET_SOCIAL_SUPPORT(state, support) {
      state.socialSupport = support
    }
  },
  actions: {
    async getSupport(store, keyword) {
      const supportData = await supportService
        .getSupportByKeyword(keyword)
        .catch(
          () => undefined
        )
      switch(keyword) {
        case KEYWORDS.PSYCHOLOGIC:
          store.commit('SET_PSYCHO_SUPPORT', supportData || null);
          break;
        case KEYWORDS.SOCIAL:
          store.commit('SET_SOCIAL_SUPPORT', supportData || null)
          break;
      }
      return supportData;
    }
  },
  getters: {
    psySupport: state => state.psySupport,
    socialSupport: state => state.socialSupport,
  }
}
